import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import EDEStatementsPage, { getDefaultPageUI } from "components/EDEStatements/pages/EDEStatementsPage";
import Classes from "model";
import { useEffect } from "react";

/**
 * @function CaptureMabiEDEStatementsMySettingsDropdown
 * @param {OBJECT} props - None used for now.
 * @description - Component for capture "006_my_settings_dropdown" in mabi23 capture group "Statements".
 */
export default function CaptureMabiEDEStatementsMySettingsDropdown(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "mobileMenu" ], { isActive: true })
    .submit();

    useEffect(() => {
        document.querySelector(".mobile [data-point=edeStatementsMainNav_Account_Access] a").click()
    }, []);

    return <EDEStatementsPage ui={ ui } />
}